<script lang="ts">
  import type { Snippet } from 'svelte';

  interface Props {
    open: boolean;
    onClose?: () => void;
    maxWidth?: string;
    children: Snippet;
  }

  let { open = $bindable(), onClose, maxWidth, children }: Props = $props();

  let dialog = $state<HTMLDialogElement>();

  $effect(() => {
    if (dialog == null) return;
    if (open && !dialog.open) {
      dialog.showModal();
    } else if (!open && dialog.open) {
      dialog.close();
    }
  });

  const closeDialog = () => {
    open = false;
    onClose?.();
  };
</script>

<dialog
  bind:this={dialog}
  onclick={(e) => {
    if (e.target === dialog) closeDialog();
  }}
  oncancel={(e) => {
    e.preventDefault();
    closeDialog();
  }}
  style:max-width={maxWidth}
>
  <div class="modal-wrapper">
    <button class="close-btn" onclick={closeDialog} aria-label="Lukk">✕</button>
    {@render children()}
  </div>
</dialog>

<style>
  dialog {
    box-sizing: border-box;
    padding: 1.5rem;
    width: 90%;
    max-width: 400px;
    border-radius: 16px;
    box-shadow: 0 10px 25px var(--shadow-md);
    background-color: var(--surface-raised);
    color: var(--text);
    border: 1px solid var(--border-strong);
    margin: auto;
  }

  dialog[open] {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  dialog::backdrop {
    background-color: var(--color-backdrop);
    backdrop-filter: blur(2px);
  }

  .modal-wrapper {
    position: relative;
    width: 100%;
  }

  .close-btn {
    background: var(--surface-raised);
    border: 1px solid var(--border-strong);
    color: var(--text-muted);
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 0;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 10;
  }
  .close-btn:hover {
    background: var(--border-subtle);
    color: var(--text);
  }
</style>
